import { render, staticRenderFns } from "./NavigationMenuDesktop.vue?vue&type=template&id=38816e29"
import script from "./NavigationMenuDesktop.vue?vue&type=script&lang=js"
export * from "./NavigationMenuDesktop.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuDesktop.vue?vue&type=style&index=0&id=38816e29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports